export enum RefundsFailReasonsEnum {
  NoMatchingTransactionsFound = 1,
  RefundAboveLimit = 2,
}



// WEBPACK FOOTER //
// ./src/app/admin/payments_refunds/refund-fail-reasons/refunds-fail-reasons.enum.ts